import { getSearchParams, UrlUtils } from '@wix/package-picker-shared';
export const getSubscriptionsUrl = _ref => {
  let {
    params
  } = _ref;
  const {
    siteGuid
  } = getSearchParams();
  const url = `/dashboard/${siteGuid}/settings/subscriptions/`;
  return UrlUtils.buildUrl({
    url,
    params
  });
};
//# sourceMappingURL=utils.js.map